import { render, staticRenderFns } from "./CommonDateFilter.vue?vue&type=template&id=6d70c56a&scoped=true"
import script from "./CommonDateFilter.vue?vue&type=script&lang=js"
export * from "./CommonDateFilter.vue?vue&type=script&lang=js"
import style0 from "./CommonDateFilter.vue?vue&type=style&index=0&id=6d70c56a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70c56a",
  null
  
)

export default component.exports